// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ToolOutlinedSvg from "@ant-design/icons-svg/es/asn/ToolOutlined";
import AntdIcon from '../components/AntdIcon';

var ToolOutlined = function ToolOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ToolOutlinedSvg
  }));
};

ToolOutlined.displayName = 'ToolOutlined';
export default React.forwardRef(ToolOutlined);